import React from "react";
import { withStyles } from "@material-ui/core/styles";

import {
  Datagrid,
  DateField,
  List,
  TextField,
  EditButton,
  TextInput,
  ShowButton,
  BooleanField,
  NumberField,
} from "react-admin";

import { MyListActions } from "../__common/MyListActions";
import { MyListPagination } from "../__common/MyListPagination";

const styles = (theme) => ({
  title: {
    maxWidth: "20em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

const filters = [
  <TextInput label="Search" source="code" alwaysOn />,
  <TextInput label="Short Description" source="short_description" />,
];

export const AntibioticsList = withStyles(styles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={filters}
    actions={<MyListActions />}
    pagination={<MyListPagination />}
    perPage={25}
  >
    <Datagrid>
      <TextField source="name" />
      <BooleanField source="is_discrete" />
      <DateField locales="es-UY" source="start_date" />
      <DateField locales="es-UY" source="end_date" />
      <TextField source="mic_susceptible_op" />
      <NumberField source="mic_susceptible" />
      <TextField source="mic_intermediate_op" />
      <NumberField source="mic_intermediate" />
      <TextField source="mic_resistant_breakpoint_op" />
      <NumberField source="mic_resistant_breakpoint" />
      <TextField source="notes" />

      <DateField
        source="createdAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <DateField
        source="updatedAt"
        locales="es-UY"
        options={{ timeZone: "UTC" }}
        showTime
      />
      <EditButton />
      <ShowButton />
    </Datagrid>
  </List>
));
